import permissions from '@/permisions.json';
import store from '@/store'
import { getUser } from "./auth";
export function getBack() {
  history.go(-1);
}

//获取登陆信息
export function userData() {
  if (store.state.user.userInfo) {
    return store.state.user.userInfo;
  } else {
    return getUser();
  }
}

/**
 * 判断路径是否有权限
 * @param url
 * @returns
 */
export function hasPermission(url) {
  const whitelist = permissions && permissions.whitelist ? permissions.whitelist : []
  // 带有token直接跳转
  const user = userData()
  if (url == '/') {
    return true
  }
  if (user.id) {
    return true
  }
  // 请求路径在白名单中直接跳转
  for (let i = 0; i < whitelist.length; i++) {
    if (url.indexOf(whitelist[i]) !== -1) {
      return true
    }
  }

  return false
}
/*
判断pc还是移动端
if (platform.isAndroid || platform.isPhone) {

} else if (platform.isTablet) {

} else if(platform.isPc) {

}
*/
export function platform() {
  var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet: isTablet,
    isPhone: isPhone,
    isAndroid: isAndroid,
    isPc: isPc
  };
};
